import { PageId } from "../common/pageId"
import _ from "lodash"
import { About } from "../pages/about/Module"
import Login from "../pages/login/Module"
import { Home } from "../pages/home/Module"
import { SlotAvailability } from "../pages/slotAvailability/Module"
import { AddFlights } from "../pages/addFlights/Module"
import { EditFlights } from "../pages/editFlights/Module"
import { Download } from "../pages/download/Module"
import { HowToApply } from "../pages/howToApply/Module"
import { routeMap } from "../components/generic/navbar/routeMap"
import { Cookies } from "../pages/cookies/Module"
import { Contact } from "../pages/contact/Module"
import { FAQ } from "../pages/FAQ/Module"
import { Disclaimer } from "../pages/Disclaimer"
import { EditMode } from "../common/transaction"
import { DisableMessageProcessing } from "../pages/disableMessageProcessing/Module"

export interface IRoutes {
  pageId: string
}
const {
  ViewFlightsGABA,
  AvailWeek,
  AvailWeekOOH,
  AvailDoop,
  AvailTime,
  AvailWeekHour,
  AvailSeasonHour,
  AvailBaseline,
  DetailWeek,
  DetailWeekOOH,
  DetailSeason,
  AddFlightsSD,
  AddFlightsSeries,
  EditFlightsSeries,
  CountReport,
  DownloadFlights,
  DownloadCancelled,
  DownloadCancelledHandling,
  ScheduleDownload,
  AddFlightsGABA,
  EditFlightsGABA,
  EditFlightsSD,
  EditSHL,
  EditOffers,
  ViewFlights,
  ViewFlightsBaseline,
  ViewFlightsEUACA,
  ViewHandling,
  AddHandling,
  EditHandling,
  SlotMonitor,
  AddSHL,
  DisableMP
} = PageId

const path = (pageId: string) => {
  return "/" + _.camelCase(pageId)
}

export enum RouteType {
  Public = "Public",
  Private = "Private",
  Login = "Login"
}

interface IRouteSpec {
  exact?: boolean
  path?: string
  pageId?: string
  render?: any
  routeType?: RouteType
}

const dateTimeAdtUrl = "/date/:date/time/:time/adt/:adt"
export const routes: IRouteSpec[] = [
  {
    path: "/",
    render: <Home />
  },

  //#region Availability
  {
    path: path(AvailWeek),
    render: <SlotAvailability pageId={AvailWeek} />
  },
  {
    path: path(AvailDoop),
    render: <SlotAvailability pageId={AvailDoop} />
  },
  {
    path: path(AvailTime),
    render: <SlotAvailability pageId={AvailTime} />
  },
  {
    path: path(AvailWeekHour),
    render: <SlotAvailability pageId={AvailWeekHour} />
  },
  {
    path: path(AvailSeasonHour),
    render: <SlotAvailability pageId={AvailSeasonHour} />
  },
  {
    path: path(AvailWeekOOH),
    render: <SlotAvailability pageId={AvailWeekOOH} />,
    routeType: RouteType.Private
  },
  {
    path: path(AvailBaseline),
    render: <SlotAvailability pageId={AvailBaseline} />
  },

  // Detail pages - parametrized
  {
    exact: false,
    path: path(DetailWeek) + dateTimeAdtUrl,
    render: <SlotAvailability pageId={DetailWeek} />
  },
  {
    exact: false,
    path: path(DetailWeekOOH) + dateTimeAdtUrl,
    render: <SlotAvailability pageId={DetailWeekOOH} />
  },
  {
    exact: false,
    path: path(DetailSeason) + dateTimeAdtUrl,

    render: <SlotAvailability pageId={DetailSeason} />
  },
  //#endregion

  //#region Flight

  // View
  {
    path: path(ViewFlights),
    render: <EditFlights pageId={ViewFlights} pageType={EditMode.VIEW} />,
    routeType: RouteType.Private
  },
  {
    path: path(ViewFlightsBaseline),
    render: (
      <EditFlights pageId={ViewFlightsBaseline} pageType={EditMode.VIEW} />
    ),
    routeType: RouteType.Private
  },
  {
    path: path(ViewFlightsEUACA),
    render: <EditFlights pageId={ViewFlightsEUACA} pageType={EditMode.VIEW} />,
    routeType: RouteType.Private
  },

  // Download
  {
    path: path(DownloadFlights),
    render: <Download pageId={DownloadFlights} />,
    routeType: RouteType.Private
  },
  {
    path: path(DownloadCancelled),
    render: <Download pageId={DownloadCancelled} />,
    routeType: RouteType.Private
  },
  {
    path: path(ScheduleDownload),
    render: <Download pageId={ScheduleDownload} />,
    routeType: RouteType.Private
  },

  // Single date
  {
    path: path(AddFlightsSD),
    render: <AddFlights pageId={AddFlightsSD} />,
    routeType: RouteType.Private
  },
  {
    exact: false,
    path: path(AddFlightsSD) + dateTimeAdtUrl,
    render: <AddFlights pageId={AddFlightsSD} />,

    routeType: RouteType.Private
  },
  {
    path: path(EditFlightsSD),
    render: <EditFlights pageId={EditFlightsSD} />,
    routeType: RouteType.Private
  },

  // Offers
  {
    path: path(EditOffers),
    render: <EditFlights pageId={EditOffers} />,
    routeType: RouteType.Private
  },

  // Series
  {
    path: path(AddFlightsSeries),
    render: <AddFlights pageId={AddFlightsSeries} />,
    routeType: RouteType.Private
  },
  {
    exact: false,
    path: path(AddFlightsSeries) + dateTimeAdtUrl,
    render: <AddFlights pageId={AddFlightsSeries} />,
    routeType: RouteType.Private
  },
  {
    path: path(EditFlightsSeries),
    render: <EditFlights pageId={EditFlightsSeries} pageType={EditMode.EDIT} />,
    routeType: RouteType.Private
  },

  // SHL
  {
    path: path(AddSHL),
    render: <AddFlights pageId={AddSHL} />,
    routeType: RouteType.Private
  },
  {
    path: path(EditSHL),
    render: <EditFlights pageId={EditSHL} />,
    routeType: RouteType.Private
  },

  // Slot monitor
  {
    path: path(SlotMonitor),
    render: <Download pageId={SlotMonitor} />,
    routeType: RouteType.Private
  },

  // Report
  {
    path: path(CountReport),
    render: <Download pageId={CountReport} />,
    routeType: RouteType.Private
  },
  //#endregion

  // Disable Message Processing
  {
    path: path(DisableMP),
    render: <DisableMessageProcessing pageId={DisableMP} />,
    routeType: RouteType.Private
  },
  //#endregion

  //#region GABA
  {
    path: path(ViewFlightsGABA),
    render: <EditFlights pageId={ViewFlightsGABA} pageType={EditMode.VIEW} />,
    routeType: RouteType.Private
  },
  {
    path: path(AddFlightsGABA),
    render: <AddFlights pageId={AddFlightsGABA} />,
    routeType: RouteType.Private
  },
  {
    exact: false,
    path: path(AddFlightsGABA) + dateTimeAdtUrl,
    render: <AddFlights pageId={AddFlightsGABA} />,
    routeType: RouteType.Private
  },
  {
    path: path(EditFlightsGABA),
    render: <EditFlights pageId={EditFlightsGABA} />,
    routeType: RouteType.Private
  },
  //#endregion

  //#region PPR
  {
    path: path(ViewHandling),
    render: <EditFlights pageId={ViewHandling} pageType={EditMode.VIEW} />,
    routeType: RouteType.Private
  },
  {
    path: path(AddHandling),
    render: <AddFlights pageId={AddHandling} />,
    routeType: RouteType.Private
  },
  // {
  //   exact: false,
  //   path: path(AddHandling) + dateTimeAdtUrl,
  //   render: <AddFlights pageId={AddHandling} />
  //   //routeType: RouteType.Private
  // },
  {
    path: path(EditHandling),
    render: <EditFlights pageId={EditHandling} />,
    routeType: RouteType.Private
  },
  {
    path: path(DownloadCancelledHandling),
    render: <Download pageId={DownloadCancelledHandling} />,
    routeType: RouteType.Private
  },
  //#endregion

  //#region Extra
  {
    path: routeMap[PageId.About],
    render: <About />
  },
  {
    path: routeMap[PageId.HowToApply],
    render: <HowToApply />
  },
  {
    path: routeMap[PageId.Cookies],
    render: <Cookies />
  },
  {
    path: routeMap[PageId.ContactUs],
    render: <Contact />
  },
  {
    path: routeMap[PageId.FAQS],
    render: <FAQ />
  },
  {
    path: routeMap[PageId.Disclaimer],
    render: <Disclaimer />
  },
  {
    path: "/login",
    render: <Login />,
    routeType: RouteType.Login
  }
  //#endregion
]
